<template>
  <div class="text-center">
    <v-progress-circular
      indeterminate
      :size="100"
      class="primary--text"
      :aria-label="$t('aria.loading')"
    />
  </div>
</template>

<i18n lang="yaml">
ja:
  aria.loading: 読み込み中

en:
  aria.loading: Loading
</i18n>

<script>
export default {
  name: 'page-load-spinner',
};
</script>

<style scoped lang="sass">
</style>
